// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"ConfigureThresholdLines_checkboxWrapper__2223C"};